// extracted by mini-css-extract-plugin
module.exports = {"typography-text":"style_typography-text__1GF-Q","typography-text__content":"style_typography-text__content__hlnfB","typography-text__prefix":"style_typography-text__prefix__eJ5yS"};